import {
    createQuestion,
    createOption,
    updateQuestion,
    updateOption,
    createQuestionTemplateStep,
    stringToHTML
} from "../helper";


export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const SM = editor.StorageManager;
    const COMMANDS = editor.Commands;
    const MD = editor.Modal;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            // droppable: false,
            droppable: ':not([data-slg-type="C-QUESTION"])',
            draggable: ':not([data-slg-type="C-QUESTION"])', 
            attributes:{
                "data-slg-type":"C-QUESTION",
                "data-slg-question-id":"",
                "data-slg-template-step-id":"",
                "data-slg-question-template-step":"",
                "data-slg-has-client":false
            },
            components:[
                {
                  type: 'C-QUESTION-TEXT'
                }
            ],
            question_text:"What is your question?"
        },
        getQuestionId(){
            return this.get('attributes')['data-slg-question-id']; 
        },
        getComponentQuestionText() {
            let component = this;
            return (component.findType('C-QUESTION-TEXT').length > 0)? component.findType('C-QUESTION-TEXT').at(0):undefined;
        },
        setComponentQuestionTextContent(content){
            let component = this;
            return component.getComponentQuestionText().setContent(content);
        },
        getQuestionText(){
            let component = this;
            return component.get('question_text');
        },
        setQuestionText(content){
            let component = this;
            return component.set('question_text',content);
        },
        /**
         * @function registerQuestion
         * @description If the question does not have UUID it will be registered, if it has UUI it will update the question
         */
        async registerQuestion(){
            let component = this;

            let storage_manager_steps = SM.get(opts.storage_name);
            let storage_steps_active = storage_manager_steps.isActive();
            let current_step = storage_manager_steps.current_step;

            let question_text = component.getComponentQuestionText().getContent();
            question_text = stringToHTML(question_text).innerText.trim();
            let attributes = component.get('attributes');
            let question_id = attributes['data-slg-question-id'];
            let template_step_id = attributes['data-slg-template-step-id'];
            if( (question_id  && !storage_steps_active) || 
                    (question_id != "" && template_step_id != "" && storage_steps_active && (current_step == template_step_id)) ){
                await updateQuestion(question_text,question_id);
                return
            }
            question_id = await createQuestion(question_text);
            component.addAttributes({
                'data-slg-question-id':question_id
            });
        },
        /**
         * @function registerQuestionByStep
         */
        async registerQuestionByStep(){
            let component = this;
            let storage_manager_steps = SM.get(opts.storage_name);
            let storage_steps_active = storage_manager_steps.isActive();
            let current_step = storage_manager_steps.current_step;
            let attributes = component.get('attributes');
            let question_template_step = attributes['data-slg-question-template-step'];
            let question_id = attributes['data-slg-question-id'];
            let template_step_id = attributes['data-slg-template-step-id'];
            
            if(!storage_steps_active || !current_step){
                // console.error("Storage step is disable!");
                return;
            }
            if(storage_steps_active  && question_template_step != "" && template_step_id != "" && template_step_id == current_step){
                // console.log("Existing relationship");
                return;
            }

            const { insertId } = await createQuestionTemplateStep(question_id, current_step);
            component.addAttributes({
                'data-slg-question-template-step':insertId,
                'data-slg-template-step-id':current_step
            });
            editor.store();
        },
        watchQuestionText(){
            let component = this;
            let component_question_text = component.getComponentQuestionText();
            component_question_text.listenTo(component_question_text,"change:content", model => {
                if(component_question_text.getContent().length != 0){
                    component.registerQuestion();
                }
            });
        },  
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-QUESTION")
                return { type:'C-QUESTION' }
        },
    });

    var view = VIEW.extend({
        init(){
            let component = this.model;
            this.listenTo(component, 'change:question_text', component.registerQuestion);
            this.init2();
        },
        init2(){},
        onRender(){
            let wrapper = editor.getWrapper();
            console.log(SM.current_step);
            /* let find = wrapper.findType('C-SPONSORS');
            if(find.length > 1){
                Swal.fire({
                    icon:'warning',
                    title: 'Already created!',
                    text: "There can only be one sponsor component",
                    heightAuto:false,
                    
                });
                this.model.remove();
                return;
            } */
        },
        
        
        
    });

    DOMC.addType('C-QUESTION', {
      model,
      view,
    });

};
  